<template>
  <div class="navbar" @click="closeNavbar">
    <div class="navbar-content">
      <router-link to="/" class="navbar-logo">
        <img src="@/assets/img/Logo_bl.svg" />
      </router-link>
      <div class="navbar-container container">
        <button @click="$emit('close')" class="navbar-burger">
          <img src="@/assets/img/close.svg" />
        </button>
        <div class="navbar-body">
          <ul :class="list.class" v-for="(list, k) in lists" :key="k">
            <li class="navbar-list__item navbar-list__item-header">
              {{ list.label }}
            </li>
            <li class="navbar-list__item" v-for="(link, i) in list.links" @click="$emit('close')" :key="i">
              <router-link :to="link.to">
                {{ link.label }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="navbar-footer">
          <ul class="navbar-list col col-2">
            <li class="navbar-list__item navbar-list__item-header">Отдел продаж</li>
            <a class="navbar-list__item" :href="`tel: ${contacts.salesNumber}`">
              {{ contacts.salesNumber }}
            </a>
          </ul>
          <ul class="navbar-list col col-2">
            <li class="navbar-list__item navbar-list__item-header">Приемная</li>
            <a class="navbar-list__item" :href="`tel: ${contacts.receptionNumber}`">
              {{ contacts.receptionNumber }}
            </a>
          </ul>
          <ul class="navbar-list col col-3 col-pl-big">
            <li class="navbar-list__item navbar-list__item-header">Почта</li>
            <a class="navbar-list__item" :href="`mailto: ${contacts.email}`">
              {{ contacts.email }}
            </a>
          </ul>
          <ul class="navbar-list col col-2">
            <li class="navbar-list__item navbar-list__item-header">Мы в социальных сетях</li>
            <li class="navbar-list__item navbar-list__item-social">
              <!-- <a :href="contacts.instagram" target="_blank" v-if="contacts.instagram">
                <img src="@/assets/img/instagram.svg" />
              </a> -->
              <a :href="contacts.vk" target="_blank" v-if="contacts.vk">
                <img src="@/assets/img/vk.svg" />
              </a>
              <a :href="contacts.facebook" target="_blank" v-if="contacts.facebook">
                <img src="@/assets/img/facebook.svg" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <img class="navbar-city" src="@/assets/img/navbar-city.png" />
    </div>
  </div>
</template>

<script>
import '@/assets/sass/navbar.sass';
import { mapState } from 'vuex';

export default {
  name: 'Navbar',
  data() {
    return {
      lists: [
        {
          label: 'О компании',
          class: 'navbar-list col col-2',
          links: [
            { label: 'Награды', to: '/achievements' },
            { label: 'Руководство', to: '/directorship' },
            { label: 'Документы', to: '/documents' },
            { label: 'Результаты СОУТ', to: '/sout' },
            { label: 'Контакты', to: '/contacts' },
          ],
        },
        {
          label: 'Сотрудничество',
          class: 'navbar-list col col-2',
          links: [
            { label: 'Заказчикам', to: '/customer' },
            { label: 'Подрядчикам', to: '/contractor' },
            { label: 'Инвесторам', to: '/investor' },
            // { label: 'Тендеры', to: '/tenders' },
            { label: 'Вакансии', to: '/career' },
          ],
        },
        {
          label: 'Проекты',
          class: 'navbar-list col col-3 col-pl-big',
          links: [
            { label: 'Портфель проектов', to: '/projects' },
            { label: 'Продажа недвижимости', to: '/estate' },
          ],
        },
        {
          label: 'Пресс-центр',
          class: 'navbar-list col col-2',
          links: [
            { label: 'Новости', to: '/news' },
            { label: 'Фотоархив', to: '/photos' },
            { label: 'Видеоархив', to: '/videos' },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      contacts: (state) => state.contacts.contacts,
    }),
  },
  methods: {
    closeNavbar(event) {
      if (!event.target.classList.contains('navbar')) return;
      this.$emit('close');
    },
  },
};
</script>
